export default {
	meta(name, cb, ecb) {
		this.http
			.get('/bean/meta/' + name, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getTotal(cb, ecb) {
		this.http
			.get('/bean/total', {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	nextCode(kind, cb, ecb) {
		this.http
			.get('/bean/nextcode', {
				params: { kind }
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/bean', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/bean', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/bean/' + id, {}).then((r) => cb && cb(r))
	},
	findSimilar(form, cb, ecb) {
		this.http
			.post('/bean/similar', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb) {
		this.http.delete('/bean/' + id, {}).then((r) => cb && cb(r))
	},
	generatePrice(id, overwrite, cb) {
		this.http
			.get(`/bean/${id}/generateprice`, {
				params: {
					overwrite: overwrite
				}
			})
			.then((r) => cb && cb(r))
	},
	searchBatch(params, cb, ecb) {
		this.http
			.get('/bean/batch', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateBatch(form, cb, ecb) {
		this.http
			.post('/bean/batch', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	undoBatch(id, cb) {
		this.http.get(`/bean/batch/${id}/undo`, {}).then((r) => cb && cb(r))
	},
	getBatchById(id, cb) {
		this.http.get('/bean/batch/' + id, {}).then((r) => cb && cb(r))
	},
	searchBatchLog(params, cb, ecb) {
		this.http
			.get('/bean/batchlog', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchStockLog(params, cb, ecb) {
		this.http
			.get('/bean/stocklog', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateStockLog(form, cb, ecb) {
		this.http
			.post('/bean/stocklog', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	undoStockLog(id, cb) {
		this.http.get(`/bean/stocklog/${id}/undo`, {}).then((r) => cb && cb(r))
	}
}
